export default __webpack_public_path__ + "static/media/express_plan_delivery.0644f380.png";